import { audiencerateApi } from '@/services/audiencerate';
import type {
  CreditBalance,
  CreditEntitlement,
  CreditReservation,
  ValidityCheckRequest,
  ValidityCheckResponse,
} from './types';

export const creditsApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    getCreditBalances: build.query<CreditBalance[], { workspaceId: string; type?: string }>({
      query: ({ workspaceId, type }) => ({
        url: `/v1/workspaces/${workspaceId}/credits/balances`,
        params: type ? { type } : undefined,
      }),
      providesTags: ['Credits'],
    }),
    getCreditEntitlement: build.query<CreditEntitlement, { workspaceId: string; type: string }>({
      query: ({ workspaceId, type }) => ({
        url: `/v1/workspaces/${workspaceId}/credits/entitlements/${type}`,
      }),
      providesTags: ['Credits'],
    }),
    checkCreditValidity: build.mutation<
      ValidityCheckResponse,
      { workspaceId: string; type: string; body: ValidityCheckRequest }
    >({
      query: ({ workspaceId, type, body }) => ({
        url: `/v1/workspaces/${workspaceId}/credits/credit-types/${type}/validity-check`,
        method: 'POST',
        body,
      }),
    }),
    getCampaignReservation: build.query<CreditReservation, { workspaceId: string; campaignId: string }>({
      query: ({ workspaceId, campaignId }) => ({
        url: `/v1/workspaces/${workspaceId}/credits/reservations/by-campaign/${campaignId}`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Credits', id: arg.campaignId }],
    }),
  }),
});

export const {
  useGetCreditBalancesQuery,
  useGetCreditEntitlementQuery,
  useCheckCreditValidityMutation,
  useGetCampaignReservationQuery,
} = creditsApi;
